// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"0a7b1fcb","89":"84e0f927","166":"db4fef56","453":"ff3cbc00","469":"74cf6a9a","529":"f2a4623f","539":"d3d32911","637":"40f903df","755":"1f27453d","920":"0eb9294a","947":"a49427b0"}[chunkId] + ".chunk.js";
};